import React from "react";

const AboutUs = () => {
  return (
    <section id="about" className="bg-[#101826] text-white py-20">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Decorative Divider */}
        <div className="w-24 h-1 bg-gradient-to-r from-[#0D47A1] to-[#1C9BF8] mx-auto mb-6"></div>

        {/* Section Title */}
        <h2 className="text-5xl font-bold text-white uppercase tracking-wide text-center">
          About Us
        </h2>

        {/* Two-Column Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mt-10">
          
          {/* Text Content - Now Structured into Sections */}
          <div className="space-y-6 text-gray-300 leading-relaxed">
            <h3 className="text-3xl font-semibold text-[#1C9BF8]">Who We Are</h3>
            <p>
            If you’re looking for a mobile car wash near you in <a href="https://maps.app.goo.gl/TV2VjzoXdVgMT4X26" className="text-[#1C9BF8]" target="_blank" rel="noopener noreferrer">Colchester</a> or across Essex, Ramon’s Supreme Auto is here to deliver top-tier car detailing 
            and valeting services wherever you need them. We know that keeping your car clean and well-maintained takes time—something 
            many of us don’t have to spare. That’s why we bring our expertise directly to you, whether you’re at home, work, or anywhere convenient.
            </p>

            <h3 className="text-3xl font-semibold text-[#1C9BF8]">The Face Behind the Business</h3>
            <p>
            Ramon, founder of RSA, is a car enthusiast with years of detailing and valeting experience.
            His passion for perfection and eye for detail ensures every vehicle receives top-tier care, from deep interior cleans to paint protection. 
            Known for his friendly service and meticulous work, he’s earned a reputation across Colchester and Essex as the go-to expert for a flawless finish.
            </p>

            <h3 className="text-3xl font-semibold text-[#1C9BF8]">Book Your Mobile Valeting & Detailing Today</h3>
            <p>
            Are you tired of waiting in queues or settling for rushed service? Let RSA bring professional valeting and detailing straight to you. 
            Whether it’s a car, van, or SUV, we guarantee a meticulously clean and flawless finish. <a href="#contact" className="text-[#1C9BF8]">Contact us</a> today.
            </p>
          </div>

          {/* Image Content */}
          <div className="rounded-lg overflow-hidden shadow-lg">
            <img
              src="https://images.unsplash.com/photo-1503736334956-4c8f8e92946d"
              alt="Luxurious car detailing"
              className="object-cover w-full h-full rounded-lg"
            />
          </div>
        </div>

        {/* Mission Statement */}
        <div className="bg-gradient-to-r from-[#0D47A1] to-[#1C9BF8] text-white rounded-lg p-6 mt-12 shadow-xl">
          <p className="text-lg font-semibold text-center italic">
            “Our mission is to redefine car care with an unwavering focus on quality and customer satisfaction.”
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;